import { mainAxios } from "@/mainAxios.js";
import { getAgenteAccessToken } from "../tokens.service";



export const getInspirumBalance = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

    const serverResponse = await mainAxios.get(
      "/v1/solicitud/inspirum/balance",
      config
    );
    
    return serverResponse.data.data
};

export const getInspirumBalanceByAlianzaId = async (alianzaId) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

    const serverResponse = await mainAxios.get(
      "/v1/solicitud/inspirum/balance/"+alianzaId,
      config
    );
    
    return serverResponse.data.data
};